import { useState, useEffect, useRef } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFReplay from '@/components/UI/svg/mm100/Icon/EFReplay';
import { createEFPic } from '@/utils/useEFPic';
import { handleDynamicPath } from '@/utils/handleDynamicPath';
const { EFPic } = createEFPic('/media/mm100/pc/');

export default function ImgShowCard({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const videoRef = useRef(null);

    const gloObj: any = {
        objA: {
            title: t('presale.product.img_show_2kWh_batteries'),
            list: [
                {
                    id: 'a1',
                    src: ['2kwh-1.webp', '2kwh-1.png'],
                    video: handleDynamicPath('/video/mm100/2000_1.mp4'),
                    text: t('presale.product.img_show_a1_text'),
                },
                {
                    id: 'a2',
                    src: ['2kwh-2.webp', '2kwh-2.png'],
                    video: handleDynamicPath('/video/mm100/2000_2.mp4'),
                    text: t('presale.product.img_show_a2_text'),
                },
                {
                    id: 'a3',
                    src: ['2kwh-3.webp', '2kwh-3.png'],
                    video: handleDynamicPath('/video/mm100/2000_3.mp4'),
                    text: t('presale.product.img_show_a3_text'),
                },
            ],
        },
        objB: {
            title: t('presale.product.img_show_5kWh_batteries'),
            list: [
                {
                    id: 'b1',
                    src: ['5kwh-1.webp', '5kwh-1.png'],
                    video: handleDynamicPath('/video/mm100/5000_1.mp4'),
                    text: t('presale.product.img_show_a1_text'),
                },
                {
                    id: 'b2',
                    src: ['5kwh-2.webp', '5kwh-2.png'],
                    video: handleDynamicPath('/video/mm100/5000_2.mp4'),
                    text: t('presale.product.img_show_a2_text'),
                },
                {
                    id: 'b3',
                    src: ['5kwh-3.webp', '5kwh-3.png'],
                    video: handleDynamicPath('/video/mm100/5000_3.mp4'),
                    text: t('presale.product.img_show_a3_text'),
                },
            ],
        },
    };
    const [curType, setCurType] = useState('objA');
    const [curList, setCurList] = useState(gloObj?.objA?.list || []);
    const [curItem, setCurItem] = useState(gloObj?.objA?.list[0] || {});
    const [videoEnterA, setVideoEnterA] = useState(false);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `.imgShowCard`,
            offset: -100, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '200%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        sceneA1.on('enter', function () {
            setVideoEnterA(true);
        });
        sceneA1.on('leave', function () {
            setVideoEnterA(false);
        });

        AniContainer.addScene(sceneA1);
    }, []);

    const clickT1 = (typeStr: string) => {
        const newList = gloObj[typeStr].list || [];
        setCurType(typeStr);
        setCurList(newList);
        clickT2(newList[0] || {});
    };

    const clickT2 = (item: any) => setCurItem(item);

    return (
        <div className={`${css.imgShowCard} imgShowCard`}>
            <div className="card-l">
                <div className="card-l-items">
                    <div className="card-l-item">
                        {videoEnterA && (
                            <video
                                ref={videoRef}
                                src={curItem?.video}
                                className="video"
                                width={673}
                                height={472}
                                loop={false}
                                autoPlay
                                muted
                                preload="auto"
                                playsInline
                            />
                        )}
                        <div className="reloadIcon" onClick={() => videoRef.current?.play()}>
                            <EFReplay />
                        </div>
                    </div>
                </div>
                <div className="card-btns">
                    <span className={`card-btn ${curType == 'objA' ? 'active' : ''}`} onClick={() => clickT1('objA')}>
                        {gloObj?.objA?.title}
                    </span>
                    <span className={`card-btn ${curType == 'objB' ? 'active' : ''}`} onClick={() => clickT1('objB')}>
                        {gloObj?.objB?.title}
                    </span>
                </div>
            </div>
            <div className="card-r">
                <div className="card-r-in">
                    {curList?.map((item: any, index: number) => (
                        <div className={`card-r-item ${curItem.id == item.id ? 'active' : ''}`} onClick={() => clickT2(item)} key={index}>
                            <EFPic name={[item.src[0], item.src[1]]} className="fullImgs" alt={item.text} />
                            <span className={`card-r-item-text text${index}`}>{item.text}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
